interface KSLogoProps {
  className?: string;
}

export function KSLogo({ className = 'h-8 w-auto' }: KSLogoProps) {
  return (
    <svg viewBox='0 0 1000 382.53' className={className} xmlns='http://www.w3.org/2000/svg'>
      <rect x='0' y='0' width='57.63' height='382.52' fill='currentColor' />
      <rect x='75.2' y='0' width='57.7' height='382.52' fill='currentColor' />
      <polygon points='150.43 225.64 208.09 304.23 208.09 382.53 150.43 382.53 150.43 225.64' fill='currentColor' />
      <polygon points='150.43 0 208.09 0 208.09 78.34 150.43 156.87 150.43 0' fill='currentColor' />
      <polygon
        points='150.43 191.29 290.87 0 526.49 0 386.12 191.29 526.49 382.53 290.87 382.53 150.43 191.29'
        fill='currentColor'
      />
      <polygon
        points='958 134.06 696.54 134.06 715.12 108.73 939.4 108.73 859.56 0 559.29 0 418.85 191.29 461.85 249.85 721.33 249.85 703.57 274.05 479.62 274.05 559.29 382.53 859.56 382.53 859.56 382.53 1000 191.25 958 134.06'
        fill='currentColor'
      />
    </svg>
  );
}
